import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { MergefieldDetailSection } from "../MergefieldDetailSection";
import React from "react";
import { useLoaderData } from "react-router";

const MergefieldsApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MergeFieldsListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <MergefieldDetailSection
        pageTitle={viewModel.pageTitle}
        availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default MergefieldsApp;